import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type EogAfeTypeValuesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EogAfeTypeValuesQuery = { __typename?: 'QueryModel', eogAfeTypeValues: { __typename?: 'EogAfeTypesQueryModel', all: Array<{ __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string }> } };


export const EogAfeTypeValuesDocument = gql`
    query EogAfeTypeValues {
  eogAfeTypeValues {
    all {
      gen
      sub
      description
      afeType
    }
  }
}
    `;

/**
 * __useEogAfeTypeValuesQuery__
 *
 * To run a query within a React component, call `useEogAfeTypeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEogAfeTypeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEogAfeTypeValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEogAfeTypeValuesQuery(baseOptions?: Apollo.QueryHookOptions<EogAfeTypeValuesQuery, EogAfeTypeValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EogAfeTypeValuesQuery, EogAfeTypeValuesQueryVariables>(EogAfeTypeValuesDocument, options);
      }
export function useEogAfeTypeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EogAfeTypeValuesQuery, EogAfeTypeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EogAfeTypeValuesQuery, EogAfeTypeValuesQueryVariables>(EogAfeTypeValuesDocument, options);
        }
export type EogAfeTypeValuesQueryHookResult = ReturnType<typeof useEogAfeTypeValuesQuery>;
export type EogAfeTypeValuesLazyQueryHookResult = ReturnType<typeof useEogAfeTypeValuesLazyQuery>;
export type EogAfeTypeValuesQueryResult = Apollo.QueryResult<EogAfeTypeValuesQuery, EogAfeTypeValuesQueryVariables>;